import { Component, inject } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { environment } from '../../../../environments/environment';
import { languages } from '../../consts/languages';
import { MenuService } from '../../services/menu.service';
import { TranslationService } from '../../services/translation.service';
import { UserService } from '../../services/user.service';
import { TranslateModule } from '@ngx-translate/core';
import { MsalService } from '@azure/msal-angular';
import { AreaContextService } from '../../services/area-context.service';
import { ThemeService } from '../../services/theme.service';
import { AsyncPipe } from '@angular/common';
import { BannerService } from '../../services/banner.service';

@Component({
  selector: 'app-header',
  imports: [TegelModule, TranslateModule, AsyncPipe],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  private readonly msal = inject(MsalService);
  private readonly menu = inject(MenuService);
  private readonly i18n = inject(TranslationService);
  private readonly user = inject(UserService);
  private readonly areaContext = inject(AreaContextService);
  readonly bannersService = inject(BannerService);
  readonly theme = inject(ThemeService);

  appName = 'CHECKLIST' + environment.envSuffix;

  languages = languages;
  currentLanguage$ = this.i18n.currentLanguage$;

  areas = this.user.areas;
  selectedArea = this.areaContext.selectedArea;

  username = this.user.username;
  useremail = this.user.useremail;
  userphoto = this.user.userphoto;
  banners = this.bannersService.banners;

  mobileMenuAction(): void {
    this.menu.setSignal(true);
  }

  changeArea(areaId: string) {
    this.areaContext.select(areaId);
    void this.bannersService.load(areaId);
  }

  changeTranslation(value: string) {
    this.i18n.setLanguage(value as any);
  }

  toggleTheme(): void {
    this.theme.toggle();
  }

  logout() {
    this.bannersService.clearDismissed();
    this.msal.logoutRedirect();
  }

  dismissBanner(id: string): void {
    this.bannersService.dismiss(id);
  }
}
